import { cardContainerMultiColumnStyles } from "@insite/content-library/Components/CardContainerMultiColumn";
import { listStyles } from "@insite/content-library/Widgets/ProductList/ProductListCardList";
import { COLORS, SPACING } from "@store/theme/design";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(cardContainerMultiColumnStyles, {
    ...cardContainerMultiColumnStyles,
    gridItem: {
        width: [12, 12, 6, 4, 4],
        css: css`
            border-top: 0;
            padding: ${SPACING.small};

            & > div {
                height: 100%;
                width: 100%;
            }
        `,
    },
    cardDivider: {
        gap: 10,
        css: css`
            border: 1px solid ${COLORS.border.base};
        `,
    },
});

merge(listStyles, {
    cardList: {
        gridContainer: {
            gap: 10,
        },
    },
    wrapper: {
        gap: 10,
        css: css`
            border-top: 0;
        `,
    },
    gridItem: {
        css: css`
            border-bottom: 0;
        `,
    },
    cardContainerStyles: {
        gridItem: {
            css: css`
                border-bottom: 0;
                height: 100%;
                width: 100%;
            `,
        },
    },
});
